import axios from 'axios'
import { clearAuthToken, getAuthToken } from '../utils/authToken'

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? 'http://localhost:3000/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
})

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthToken()
      // Guard against SSR — the interceptor itself can theoretically
      // run server-side if a query were to fire during prerender.
      if (typeof window !== 'undefined') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  },
)

export async function signIn(email: string, password: string): Promise<{ token: string }> {
  const { data } = await apiClient.post<{ token: string }>('/auth/sessions', {
    user: { email, password },
  })
  return data
}
